import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { FormErrorMessagesComponent } from './core/components/form-error-messages/form-error-messages.component';
import { Actions } from '@ngxs/store';
import { VxToastStackComponent } from '@ui/toast/toast-stack.component';
import { DocumentTitleService } from './services/document-title/document-title.service';
import { TranslationService } from './services/translation/translation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, VxToastStackComponent, FormErrorMessagesComponent],
})
export class AppComponent {
  private actions = inject(Actions);
  private router = inject(Router);

  // initialize the translation service to load the preferred language for the user
  private translateService = inject(TranslationService);

  // mirrors the active page into the browser tab title
  private documentTitleService = inject(DocumentTitleService);
}
